import { ITexture } from "./Texture";

export class MaterialManager {
    private textureMap: Map<string, ITexture>;

    constructor() {
        this.textureMap = new Map<string, ITexture>();
    }

    public addTexture(reference: string, texture: ITexture) {
        this.textureMap.set(reference, texture);
    }

    public getTexture(reference: string): ITexture {
        if (this.textureMap.has(reference)) {
            return this.textureMap.get(reference);
        } else {
            throw new Error(`No texture with reference ${reference} is loaded`);
        }
    }
}
